<template>
  <div>
    <div v-if="error" class="alert alert-primary bg-primary text-white border-0 show">
      {{$t(error)}}
    </div>

    <b-form novalidate @submit.prevent="submit">
      <div class="row">
        <div class="col-lg-6">
          <validated-form-input name="name" label="Nimi" placeholder="Sisesta nimi" v-model="user.name"
                                validate="required" :validator="$validator"/>

          <validated-form-input name="personalCode" label="Isikukood" placeholder="Sisesta isikukood"
                                v-model="user.personalCode"
                                validate="required" :validator="$validator"/>

          <validated-form-select name="object" :options="objects" label="Objekt" text-field="label" value-field="code"
                                 placeholder="- Vali objekt -" v-model="user.objectId" validate="required"
                                 :validator="$validator"/>
        </div>

        <div class="col-lg-6">
          <validated-form-input name="email" label="E-mail" placeholder="E-Mail" v-model="user.email"
                                validate="required|email" :validator="$validator"/>

          <validated-form-input name="phone" label="Telefon" placeholder="Telefon" v-model="user.phone"
                                :validate="{ required: true, regex: /^\+?[0-9 ]+$/ }" :validator="$validator"/>

          <validated-form-input name="adminCode" label="Kasutajakood" placeholder="Kasutajakood"
                                v-model="user.adminCode"
                                :validate="{ required: true, regex: /\D{2}/ }" :validator="$validator"/>

        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <validated-form-input name="username" label="Kasutajanimi" placeholder="Kasutajanimi" v-model="user.username"
                                validate="required" :validator="$validator"/>

        </div>

        <div class="col-lg-6">
          <validated-form-input name="password" type="password" label="Parool" placeholder="Parool"
                                v-model="user.password" :validator="$validator"/>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <b-form-checkbox v-model="user.withSignatureRight" :value="true" :unchecked-value="false">
            Allkirjastamise õigus
          </b-form-checkbox>
          <b-form-checkbox v-model="user.withAdministrationRight" :value="true" :unchecked-value="false">
            Administraatori õigus
          </b-form-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary" :disabled="submitting">Salvesta</submit-button>
        </div>
      </div>

    </b-form>

  </div>
</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import ValidatedFormSelect from '@/components/ValidatedFormSelect'

  export default {
    props: ['userId'],
    components: {ValidatedFormInput, ValidatedFormSelect},
    data() {
      return {
        user: {
          name: null,
          personalCode: null,
          objectId: null,
          email: null,
          phone: null,
          adminCode: null,
          username: null,
          password: null,
          withAdministrationRight: false,
          withSignatureRight: false
        },
        objects: [],
        submitting: false,
        error: null
      }
    },
    created() {
      this.$gateway.get(`/admin/users/${this.userId}`).then(r => {
        this.user = r.data;
      })
      this.$gateway.get('/configuration/invoice-prefixes').then(r => {
        this.objects = r.data
      })
    },
    methods: {
      submit() {
        if (this.submitting) return;
        this.submitting = true

        this.$validator.validateAll().then(valid => {
          if (!valid) {
            this.submitting = false
            return
          }
          this.$gateway.post(`/admin/users/${this.user.id}`, this.user)
            .then(r => {
              this.$notifications.info(`Kasutaja ${this.user.name} on muudetud`)
              this.submitting = false
              this.$emit('done')
            })
            .catch(r => {
              this.error = r.response.data.key
              this.submitting = false
            })
        })
      }
    }
  }
</script>
